import { createAction, props } from "@ngrx/store";
import type { ChatAttachmentUploadRequest as ChatAttachmentUploadPayload, ChatDeleteRequest as ChatDeletePayload, ChatEditRequest as ChatEditPayload, ChatGetRequestPayload, ChatListResponse, ChatReactionRequest as ChatReactionPayload } from "./chat.models";

export const ChatGetRequest = createAction(
  '[Chat] Get Request',
  props<{ payload: ChatGetRequestPayload }>()
);

export const ChatGetSuccess = createAction(
  '[Chat] Get Success',
  props<{ channelId: string; mode: 'replace' | 'prepend'; response: ChatListResponse }>()
);

export const ChatGetFailure = createAction(
  '[Chat] Get Failure',
  props<{ error: string }>()
);

export const ChatValidationError = createAction(
  '[Chat] Validation Error',
  props<{ validationErrors: any }>()
);

export const ChatDeleteRequest = createAction(
  '[Chat] Delete Request',
  props<{ payload: ChatDeletePayload }>()
);

export const ChatDeleteSuccess = createAction(
  '[Chat] Delete Success',
  props<{ channelId: string; messageId: string; message: string }>()
);

export const ChatDeleteFailure = createAction(
  '[Chat] Delete Failure',
  props<{ error: string }>()
);

export const ChatEditRequest = createAction(
  '[Chat] Edit Request',
  props<{ payload: ChatEditPayload }>()
);

export const ChatEditSuccess = createAction(
  '[Chat] Edit Success',
  props<{ channelId: string; messageId: string; message: string }>()
);

export const ChatEditFailure = createAction(
  '[Chat] Edit Failure',
  props<{ error: string }>()
);

export const ChatAttachmentUploadRequest = createAction(
  '[Chat] Attachment Upload Request',
  props<{ payload: ChatAttachmentUploadPayload }>()
);

export const ChatReactionRequest = createAction(
  '[Chat] Reaction Request',
  props<{ payload: ChatReactionPayload }>()
);

export const ChatReactionSuccess = createAction(
  '[Chat] Reaction Success',
  props<{ channelId: string; messageId: string; message: string }>()
);

export const ChatReactionFailure = createAction(
  '[Chat] Reaction Failure',
  props<{ error: string }>()
);

export const ChatAttachmentUploadSuccess = createAction(
  '[Chat] Attachment Upload Success',
  props<{ channelId: string; message: string }>()
);

export const ChatAttachmentUploadFailure = createAction(
  '[Chat] Attachment Upload Failure',
  props<{ error: string }>()
);
